import { FilterFieldEditorType } from '@warebee/shared/common';
import { LocationDataColumn } from '@warebee/shared/dataset-queries';
import { TFunction } from 'i18next';
import { FilterFieldConfig } from '../../common/types';
import { Formatter } from '../../common/useFormatter';
import i18n from '../../i18n';

export function getLocationFilterConfigDefault(
  t: TFunction<'dataset'> = i18n.t,
  formatter?: Formatter,
): FilterFieldConfig<LocationDataColumn>[] {
  return [
    {
      type: 'locationOrder',
      title: t('Location Order', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
    },
    {
      type: 'locationStatus',
      title: t('Location Status', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
    },
    {
      type: 'locationLevel',
      title: t('Level', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
    },
    {
      type: 'locationLength',
      title: t('Length', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.SliderRange,
    },
    {
      type: 'locationWidth',
      title: t('Width', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.SliderRange,
    },
    {
      type: 'locationHeight',
      title: t('Height', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.SliderRange,
    },
    {
      type: 'locationWeight',
      title: t('Weight', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.SliderRange,
    },
    {
      type: 'locationBayId',
      title: t('Bay Id', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
    },
    // {
    //   type: 'locationBayTitle',
    //   title: t('Location Bay Title', { ns: 'dataset' }),
    //   editorType: FilterFieldEditorType.MultipleCheck,
    // },
    {
      type: 'locationBayPosition',
      title: t('Location Bay Position', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
    },
    {
      type: 'locationDepthPosition',
      title: t('Location Depth Position', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
    },
    {
      type: 'locationUsageType',
      title: t('Usage Type', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
    },
    {
      type: 'locmhtype',
      title: t('MHE Type', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
    },
    {
      type: 'locationRackingType',
      title: t('Racking Type', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
    },
    {
      type: 'warehouseArea',
      title: t('Area', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
    },
    {
      type: 'locationSide',
      title: t('Side', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
    },
    {
      type: 'congestionZone',
      title: t('Work Zone', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
    },
    {
      type: 'locationBayProjection',
      title: t('Location Bay Projection', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
    },
    {
      type: 'locationHeightFromFloor',
      title: t('Location Height From Floor', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
    },
    {
      type: 'locationDepthFromFront',
      title: t('Location Depth From Front', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
    },
    {
      type: 'locationIndexFromFront',
      title: t('Location Index From Front', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
    },
    {
      type: 'bayType',
      title: t('Bay Type', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
    },
    // {
    //   type: 'aisleId',
    //   title: t('Aisle Id', { ns: 'dataset' }),
    //   editorType: FilterFieldEditorType.MultipleCheck,
    // },
    {
      type: 'aisleTitle',
      title: t('Aisle', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
    },
    // {
    //   type: 'planeId',
    //   title: t('Plane Id', { ns: 'dataset' }),
    //   editorType: FilterFieldEditorType.MultipleCheck,
    // },
    {
      type: 'planeTitle',
      title: t('Floor', { ns: 'dataset' }),
      editorType: FilterFieldEditorType.MultipleCheck,
    },
  ];
}
